import { XMarkIcon } from '@heroicons/react/24/outline';

import { useCart } from '@frontend/storefront/components/cart/cart-context';
import type { CartItem } from '@frontend/storefront/lib/shopify/types';

export function DeleteItemButton({ item }: { item: CartItem }) {
  const { updateCartItem, isUpdating } = useCart();

  return (
    <button
      type="button"
      disabled={isUpdating || !item.id}
      aria-label="Remove cart item"
      onClick={() => updateCartItem(item.id!, 'delete')}
      className="flex h-[24px] w-[24px] items-center justify-center rounded-full bg-np-ink/60"
    >
      <XMarkIcon className="mx-[1px] h-4 w-4 text-np-bg" />
    </button>
  );
}
